import { NavigateFunction } from 'react-router-dom';

export interface LoginViewModel {
  phone: string;
  auth: (rawOtp: any) => Promise<void>;
  navigate: NavigateFunction | null;
  state: 'pin' | 'shareContact' | 'otp';
  setPin: (rawPin: any) => void;
  onShareContactSuccess: () => Promise<void>;
  isContacted: boolean;
  botUrl: string;

  /** OSI-797: i18n-ключ ошибки прошлой попытки (алерт над формой пароля) */
  authErrorKey: string | null;
  /** OSI-797: открыта ли модалка блокировки */
  isBlocked: boolean;
  /** OSI-797: минут до снятия блокировки */
  blockedMinutes: number;
  /** OSI-797: ключ для форсированного remount форм PinCode/OtpCheck */
  attemptId: number;

  goToPin: () => void;
  dismissBlock: () => void;
  clearAuthError: () => void;
}

export const LoginViewModelToken = Symbol.for('LoginViewModel');
